import { AutoCompleteSelectedMode, UnitAutoCompleteHierarchicalModel } from 'components/MprcAutoCompleteHierarchical/AutoCompleteHierarchicalModel';
import { MprcSimpleDialog } from 'components/MprcSimpleDialog';
import React, { useState } from 'react';
import { UnitAutoCompleteHierarchical } from './UnitAutoCompleteHierarchical';
import { useTranslation } from 'react-i18next';
import { ButtonCancel, ButtonConfirm } from 'components/buttons';

interface IProps {
    title?: string;
    selectedItems: UnitAutoCompleteHierarchicalModel[];
    unitTypeId?: string;
    unitTypeName?: string;
    multiSelect: boolean;
    selectedMode?: AutoCompleteSelectedMode;
    showDescendantOption?: boolean;

    onChange: (item: UnitAutoCompleteHierarchicalModel[]) => void;
    onError: (error: any) => void;
    onClose: () => void;
}

export const UnitSelectionDialog: React.FC<IProps> = ({ title, onClose, onChange, selectedItems, selectedMode = "free", ...rest }) => {

    const { t } = useTranslation();

    const [items, setItems] = useState<UnitAutoCompleteHierarchicalModel[]>(selectedItems);

    return <MprcSimpleDialog
        title={title ?? (rest.multiSelect ? t("Unit.UnitSelectionDialog.Title_other") : t("Unit.UnitSelectionDialog.Title_one"))}
        subtitle={rest.unitTypeName}
        message={
            <UnitAutoCompleteHierarchical
                selectedMode={selectedMode!}
                selectedItems={items}
                onChange={items => setItems(items as UnitAutoCompleteHierarchicalModel[])}
                autoFocus={true}
                {...rest}
            />
        }
        width="md"
        actions={
            <>
                <ButtonCancel onClick={onClose} />
                <ButtonConfirm
                    text="Aplicar"
                    variant="contained"
                    disabled={items.length === 0}
                    onClick={() => onChange(items)}
                />
            </>
        }
        onClose={onClose}
    />;
};
